"use client";

interface PricingHeroProps {
  title: string;
  description: string;
  className?: string;
}

export function PricingHero({ title, description, className }: PricingHeroProps) {
  return (
    <div className={`relative max-w-full bg-gradient-to-b from-0% from-card to-[50vh] to-background ${className || ''}`}>
      <div className="absolute left-1/2 z-10 ml-[-500px] h-[500px] w-[1000px] rounded-full bg-gradient-to-r from-primary to-bg opacity-20 blur-[150px]" />
      
      <div className="container relative z-20 pt-44 pb-12 text-center lg:pb-16">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-4xl lg:text-6xl font-bold tracking-tight mb-6">
            {title}
          </h1>
          
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}

